<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('Partner dividend splits')"
          :description="$t('From here you can control partners profits')"
        />
        <indexTable
          :searchText="$t('Search for a process')"
          :emptyTableText="$t('There are no partners profits')"
          :emptyTableSubText="$t('Try adding some and try again')"
          :buttonRole="$checkRole('partners_profits_add')"
          :statusSearch="true"
          :statusValues="[
            { title: $t('Situation'), value: '' },
            { title: $t('All'), value: '' },
            { title: $t('Draft'), value: 0 },
            { title: $t('Approved'), value: 1 }
          ]"
          :cloumns="[
            {
              column: 'code',
              title: $t('Reference'),
              type: 'mainLink',
              sort: true
            },
            {
              column: 'safe_id',
              title: $t('Project'),
              type: 'link',
              to: 'project',
              sort: true,
              link: true
            },
            { column: 'date', title: $t('Payment date'), type: 'text', sort: true },
            { column: 'total', title: $t('Amount'), type: 'text', sort: true },
            {
              column: 'description',
              title: $t('Thats about'),
              type: 'text',
              sort: true
            },
            {
              column: 'user_name',
              title: $t('Responsible name'),
              type: 'text',
              sort: true,
              icon: 'usd-square'
            },
            {
              column: 'status',
              title: $t('Situation'),
              type: 'status',
              sort: true,
              values: [
                { title: $t('Draft'), value: 0, color: 'dark' },
                { title: $t('Approved'), value: 1, color: 'success' }
              ]
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                { name: 'show' },
                { name: 'edit', role: $checkRole('partners_profits_edit') },
                { name: 'file' },
                { name: 'delete', role: $checkRole('partners_profits_delete') }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'

export default {
  data() {
    return {
      path: '/partnersProfits'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
